module.exports = __webpack_public_path__ + "static/img/click.2871b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/click.png
// module id = K5xN
// module chunks = 2